// AdminWidgetsSpec.staff.js — 직원 그룹 위젯 spec (2026-06-08 회사별 분리)
//
// 회사 무관 (3종):
//   admin_attendance_today / admin_leave_today / admin_emergency_event_recent
//
// 회사별 (PINE/DOT/LNJ 각각 — .staff-companies.js 에서 fan-out):
//   admin_payroll_{cc} / admin_incentive_{cc} / admin_renewal_{cc}
//
// 공통 render 함수는 .staff-renders.js 로 분리 (circular import 회피).

import React from 'react';
import { Siren } from 'lucide-react';
import { WIDTHS } from './widgetFormat';
import { STAFF_COMPANY_SPECS } from './AdminWidgetsSpec.staff-companies';

const ATTN = 'text-amber-700';
const ATTN_BG = 'bg-amber-50';

// 6. 비상대응 담당자
function renderEmergency(d) {
  if (!d) return '-';
  const tw = d.thisWeek || {};
  const na = d.nextAvailable;
  const fmtD = (ymd) => {
    if (!ymd) return '';
    const [, m, dd] = ymd.split('-');
    return `${Number(m)}/${Number(dd)}`;
  };
  return (
    <span className="flex flex-col items-end gap-1">
      <span className="text-base font-black text-[var(--text-main)]">
        이번주 {tw.name ? tw.name : <span className={ATTN}>미배정</span>}
      </span>
      <span className={`text-[11px] ${na ? `${ATTN_BG} ${ATTN} px-1 py-px rounded font-semibold` : 'text-[var(--text-muted)]'}`}>
        {na ? `${fmtD(na.weekStart)} 할당 가능` : '6개월 내 빈 슬롯 없음'}
      </span>
    </span>
  );
}

// 회사 무관 spec (2종) + 회사별 spec (9종 = 3 위젯 × 3 회사)
export const STAFF_SPECS = {
  admin_emergency_event_recent: {
    Icon: Siren, label: '비상대응', width: WIDTHS.WIDE, accent: 'rose', size: 'S',
    render: renderEmergency,
    watermarkIcon: Siren,
  },
  ...STAFF_COMPANY_SPECS,
};
